/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import { cloneDeep } from 'lodash';

import {
    CLEAR_COLLECTION,
    FETCH_COLLECTION_SUCCESS, CHANGE_COLLECTION_TITLE,
    CHANGE_COLLECTION_TRIMSIZE,
    SET_PRIVATE_RESOURCE_STATUS
} from '../_actions/collection.actions';

import {
    SET_COURSE_NAME,
    SET_ORG_UNIT,
    SET_COURSE_NO,
    SET_ESTIMATED_ENROLLMENTS,
    SET_CLASS_START,
    SET_END_START
} from "../_actions/order.details.actions";

export const INITIAL_STATE = {
};

export function collectionReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_COLLECTION_SUCCESS: {
            return action.payload;
        }
        case CLEAR_COLLECTION: {
            return INITIAL_STATE;
        }
        case CHANGE_COLLECTION_TITLE: {
            return { ...state, title: action.title };
        }
        case CHANGE_COLLECTION_TRIMSIZE: {
            return { ...state, trimSize : { name : action.trimSize , orientation: state.trimSize.orientation} };
        }
        case SET_COURSE_NAME :{
            const courseInfo = cloneDeep(state.collectionCourseInformation);
            courseInfo.courseTitle = action.payload;
            return { ...state, collectionCourseInformation: courseInfo};
        }
        case SET_COURSE_NO :{
            const courseInfo = cloneDeep(state.collectionCourseInformation);
            courseInfo.courseNo = action.payload;
            return { ...state, collectionCourseInformation: courseInfo};
        }
        case SET_ESTIMATED_ENROLLMENTS :{
            const courseInfo = cloneDeep(state.collectionCourseInformation);
            courseInfo.estimatedQty = action.payload;
            return { ...state, collectionCourseInformation: courseInfo};
        }
        case SET_CLASS_START :{
            const courseInfo = cloneDeep(state.collectionCourseInformation);
            courseInfo.classStart = action.payload;
            return { ...state, collectionCourseInformation: courseInfo};
        }
        case SET_END_START :{
            const courseInfo = cloneDeep(state.collectionCourseInformation);
            courseInfo.classEnd = action.payload;
            return { ...state, collectionCourseInformation: courseInfo};
        }
        case SET_PRIVATE_RESOURCE_STATUS: {
            return {...state, hasPrivateResources: action.payload};
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/collection.reducer.js